import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { FloatingCardArrow } from '../../component-floating-card';
import { forwardRef } from 'react';
/**
 * The `PopoverArrow` component is used to render arrow within popover component
 */
export const PopoverArrow = forwardRef((props, ref) => (_jsx(FloatingCardArrow, { variant: "default", ...props, ref: ref })));
PopoverArrow.displayName = 'PopoverArrow';
